export const STRATEGY_CALL_BAR = {
    "onMute": function (json) {
        if (typeof onMute === 'function') {
            onMute(json.data);
        }
    },
    "onHold": function (json) {
        if (typeof onHold === 'function') {
            onHold(json.data);
        }
    },
}


// WEBPACK FOOTER //
// ./src/Strategies/strategyCallBar.js